import { PublicKey } from "@solana/web3.js";
import { makeDSTProgram } from "./makeDSTProgram.js";
import { Provider } from "@coral-xyz/anchor";

export function setStakeTarget({
  dst,
  director,
  operator,
  stakeTarget,
  provider,
}: {
  dst: PublicKey;
  director: PublicKey;
  operator: PublicKey;
  stakeTarget: PublicKey;
  provider?: Provider;
}) {
  const program = makeDSTProgram(provider);
  const result = program.methods.setStakeTarget().accountsPartial({
    dst,
    operator,
    //clock: SYSVAR_CLOCK_PUBKEY,
    //directedStakeProgram: program.programId,
    director,
    stakeTarget,
  });

  return result;
}
